import React from 'react';
import { useLocation } from 'react-router-dom';

const style1 = {
  backgroundColor:"#046B5E",
  height:"30px",
  zIndex:"100",
  position:"fiexd",
};

const styleFont = {
  fontFamily:"arial"
}
// EC連携タイマー
const EC_OPEN = new Date(2022, (2-1), 9, 12 , 5);
const OPENline = parseInt( EC_OPEN / 1000 );
const dateCurrent = parseInt( new Date() / 1000 );

function Header(){
  const location = useLocation();
  console.log(location.pathname)
  if (location.pathname === '/light/') {
    return (
      <div
        className = "head w-100 text-white sticky-top"
        style= { style1 } 
      >
      </div>
    )
  }else if(location.pathname === '/light/cg'){
    return (
      <div
        className = "head w-100 text-white sticky-top"
        style= { style1 } 
      >
      </div>
    )
  }else if(location.pathname === '/light/photo'){
    return (
      <div
        className = "head w-100 text-white sticky-top"
        style= { style1 } 
      >
      </div>
    )
  }

  return(
    <div
      className = "head w-100 text-white sticky-top"
      style= { style1 } 
    >
      <div className="container">
        <div className="row justify-content-between d-flex py-1">
          <div className="col-3 my-box align-self-center">
            <a href="/">
              <i className="fas fa-home text-white">
              </i>
            </a>
          </div>
          <div className="col-6 text-white text-center align-self-center">
            <a 
              href = "/"
              className = "text-white font-weight-bold"
            >
            </a>
          </div>
          <div className="col-3 text-center align-self-center">
            <div className="container">
            {(OPENline >= dateCurrent)?
              <div 
                className = "row justify-content-center font-italic"
                style = { styleFont }
              >
                Ver.4.0.6
              </div>
              :
              <div 
                className = "row justify-content-center font-italic"
                style = { styleFont }
              >
                Ver.5.1.0
              </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;
